import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import LocationData from "./LocationModel/LocationData"

export default function LocationsGetObservable(portalID: number, companyID: number, name: string, showInactive: boolean = false): Observable<LocationData[]> {
  const requestBody: string = JSON.stringify({ ImplementationID: portalID, CompanyID: companyID, LocationName: name, ShowInactive: showInactive })

  return ObservableFromFetch<LocationData[]>("FFOrderClientFileMaintenance/GetLocationInformation", requestBody)
}
